import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useAuthStateValue } from "../Auth/AuthState";

export type FetchRequest = {
  url: string,
  method: string,
  body?: any,
  isFormData?: boolean
}

const useFetch = (request?: FetchRequest, cancel?: boolean) => {
  const cancelRequest = useRef(false);

  const [responseStatusCode, setResponseStatusCode] = useState<number>();
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [requestUrl, setRequestUrl] = useState<string>("");

  useEffect(() => {
    const abortController = new AbortController();

    cancelRequest.current = false;

    if (cancel && cancel === true) {

      cancelRequest.current = true;
      abortController.abort();
    }
    else {
      if (request) {
        const { url, method, body, isFormData } = request;
        setRequestUrl(url);

        let bodyData: any = null;

        // Set header
        let hdr: any = {
          'Authorization': {} ? `Bearer {}` : '',
          'Access-Control-Allow-Origin': 'https://admin-dev.pkgloop.com/'
        };
        if (isFormData && isFormData === true) {
          // Note: Header contentType should be left blank for multipart/form-data as it provides its own
          bodyData = body;
        }
        else {
          hdr = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': 'https://admin-dev.pkgloop.com/',
            'Referrer-Policy': 'strict-origin-when-cross-origin'
          };
          bodyData = JSON.stringify(body);
        }

        const fetchData = async () => {
          setIsLoading(true);

          try {
            const result = await fetch(url, {
              method: method,
              headers: hdr,
              body: bodyData,
              signal: abortController.signal
            });

            setResponseStatusCode(result.status);

            if (result.ok) {

              if (cancelRequest.current === false && !abortController.signal.aborted) {
                const json = await result.json();
                setData(json);
                setError(null);
              }

            }
            else {
              const json = await result.json();
              setError(json);

              if (result.status === 400 && (!!json.errors || json.message)) {
                // Validation error.
                let errorText: string = `Please check the form for errors.`;
                toast.error(errorText, { hideProgressBar: true });
              } else if (result.status === 401) {
                // Authentication error.
                let errorText: string = `Unauthenticated. Please re-login.`;
                toast.error(errorText, { hideProgressBar: true });
              } else if (result.status === 403) {
                // Authorization error.
                let errorText: string = `Unauthorized.`;
                toast.error(errorText, { hideProgressBar: true });
              } else {
                let errorText: string = `Internal Error: ${result.status}`;
                toast.error(errorText, { hideProgressBar: true });
              }
            }

          } catch (error) {
            if (!abortController.signal.aborted) {
              setIsLoading(false);
            }

          } finally {
            if (!abortController.signal.aborted) {
              setIsLoading(false);
            }

            //cancelRequest.current = true;
          }

        };

        fetchData();
      }

    }

    return () => {

      cancelRequest.current = true;
      abortController.abort();
    };

  }, [request]);

  return ({ responseStatusCode, data, error, isLoading });
}

export default useFetch;


// export type FetchOptions = {
//    method?: "GET" | "POST" | "DELETE" | "PATCH" | "PUT" | "HEAD" | "OPTIONS" | "CONNECT";
//    headers?: any;
//    body?: any;
//    mode?: "cors" | "no-cors" | "same-origin";
//    credentials?: "omit" | "same-origin" | "include";
//    cache?: "default" | "no-store" | "reload" | "no-cache" | "force-cache" | "only-if-cached";
//    redirect?: "follow" | "error" | "manual";
//    referrer?: string;
//    referrerPolicy?: "referrer" | "no-referrer-when-downgrade" | "origin" | "origin-when-cross-origin" | "unsafe-url";
//    integrity?: any;
//    signal?: any;
// }

// type FetchProps = {
//    url: string,
//    options?: any
// }
